import React, { useContext, useEffect, useState } from "react";
import Select, { StylesConfig, components } from 'react-select';
import SideMenuCommonFilter from "../../../contextApi/SideMenuCommonFilter";
import SideMenuCommonFilterLib from "../../../contextApi/SideMenuCommonFilterLib";

const FilterStateZoneZipcodeWidget = (props) => {

    const {
        ele,
        filterBtnsSelected,
        openFilterLayout,
        setFilterBtnsSelected,
    } = props;

    const [sideMenuCommonFilterContext, setSideMenuCommonFilterContext] = useContext(SideMenuCommonFilter);
    const [sideMenuCommonFilterLibContext, setSideMenuCommonFilterLibContext] = useContext(SideMenuCommonFilterLib);

    const [isStateMenuOpen, setIsStateMenuOpen] = useState(false);
    const [isZoneMenuOpen, setIsZoneMenuOpen] = useState(false);
    const [isZipcodeMenuOpen, setIsZipcodeMenuOpen] = useState(false);
    const [states, setStates] = useState([...filterBtnsSelected.report_states]);
    const [zones, setZones] = useState([...filterBtnsSelected.report_zones]);
    const [zipcodes, setZipcodes] = useState([...filterBtnsSelected.report_zipcodes]);

    const removeAllVal = (defaultValue) => {
        return defaultValue.filter(defaultValueSigle => {
            return defaultValueSigle.value != 'ALL';
        });
    };

    const populateValues = (defaultValue) => {
        if (defaultValue.length) {
            return defaultValue.filter(defaultValueSigle => {
                return defaultValueSigle.value != 'ALL';
            });
        } else {
            return [{
                label: "ALL",
                value: "ALL",
                isFixed: true
            }]
        }
    };

    const selectedStateValues = () => {
        return states.map(state => {
            return {
                label: state,
                value: state
            };
        });
    };

    const selectedZoneValues = () => {
        return zones.map(zone => {
            return {
                label: zone,
                value: zone
            };
        });
    };

    const selectedZipcodeValues = () => {
        return zipcodes.map(zipcode => {
            return {
                label: zipcode,
                value: zipcode
            };
        });
    };

    const getStatesOptions = () => {
        let statesArr = [];
        let allZipcodes = [];
        if (sideMenuCommonFilterLibContext.comp_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.comp_zipcode);
        }
        if (sideMenuCommonFilterLibContext.tenant_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.tenant_zipcode);
        }

        allZipcodes.map(zipcodeObj => {
            if (!statesArr.includes(zipcodeObj.state)) {
                let valid = true;
                if (zipcodes.length && !zipcodes.includes(zipcodeObj.zipcode)) {
                    valid = false;
                }
                if (zones.length && !zones.includes(zipcodeObj.zone)) {
                    valid = false;
                }
                if (valid && zipcodeObj.state) {
                    statesArr.push(zipcodeObj.state);
                }
            }
        });
        return statesArr.map(statesArrSignle => {
            return {
                label: statesArrSignle,
                value: statesArrSignle
            };
        })
    };

    const getZonesOptions = () => {
        let zonesArr = [];
        let allZipcodes = [];
        if (sideMenuCommonFilterLibContext.comp_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.comp_zipcode);
        }
        if (sideMenuCommonFilterLibContext.tenant_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.tenant_zipcode);
        }

        allZipcodes.map(zipcodeObj => {
            if (!zonesArr.includes(zipcodeObj.zone)) {
                let valid = true;
                if (zipcodes.length && !zipcodes.includes(zipcodeObj.zipcode)) {
                    valid = false;
                }
                if (states.length && !states.includes(zipcodeObj.state)) {
                    valid = false;
                }
                if (valid && zipcodeObj.zone) {
                    zonesArr.push(zipcodeObj.zone);
                }
            }
        });
        return zonesArr.map(zonesArrSignle => {
            return {
                label: zonesArrSignle,
                value: zonesArrSignle
            };
        })
    };

    const getZipcodesOptions = () => {
        let zipcodesArr = [];
        let allZipcodes = [];
        if (sideMenuCommonFilterLibContext.comp_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.comp_zipcode);
        }
        if (sideMenuCommonFilterLibContext.tenant_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.tenant_zipcode);
        }

        allZipcodes.map(zipcodeObj => {
            if (!zipcodesArr.includes(zipcodeObj.zipcode)) {
                let valid = true;
                if (states.length && !states.includes(zipcodeObj.state)) {
                    valid = false;
                }
                if (zones.length && !zones.includes(zipcodeObj.zone)) {
                    valid = false;
                }
                if (valid && zipcodeObj.zipcode) {
                    zipcodesArr.push(zipcodeObj.zipcode);
                }
            }
        });
        return zipcodesArr.map(zipcodesArrSingle => {
            return {
                label: zipcodesArrSingle,
                value: zipcodesArrSingle
            };
        })
    };

    const setFinalValues = () => {
        let newSet = { ...filterBtnsSelected};
        let newSideMenuCommonFilterContext  = {...sideMenuCommonFilterContext};

        newSet['report_states'] = states;
        newSet['report_zones'] = zones;
        newSet['report_zipcodes'] = zipcodes;

        newSideMenuCommonFilterContext['report_states'] = states;
        newSideMenuCommonFilterContext['report_zones'] = zones;
        newSideMenuCommonFilterContext['report_zipcodes'] = zipcodes;

        setFilterBtnsSelected(newSet);
        setSideMenuCommonFilterContext(newSideMenuCommonFilterContext);
    };

    const renderStateSelect = () => {
        return (<Select
            isMulti={true}
            menuIsOpen={isStateMenuOpen}
            onFocus={e => setIsStateMenuOpen(true)}
            onBlur={e => {
                setIsStateMenuOpen(false);
                setFinalValues();
            }}
            components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MultiValue }}
            hideSelectedOptions={false}
            styles={styles}
            value={populateValues(selectedStateValues())}
            isClearable={selectedStateValues().length != 0}
            onChange={items => {
                setStates(removeAllVal(items).map(item=>item.value));
            }}
            options={getStatesOptions()}
            placeholder="Select States"
            menuPortalTarget={document.body}
        />);
    }

    const renderZoneSelect = () => {
        return (<Select
            isMulti={true}
            menuIsOpen={isZoneMenuOpen}
            onFocus={e => setIsZoneMenuOpen(true)}
            onBlur={e => {
                setIsZoneMenuOpen(false);
                setFinalValues();
            }}
            components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MultiValue }}
            hideSelectedOptions={false}
            styles={styles}
            value={populateValues(selectedZoneValues())}
            isClearable={selectedZoneValues().length != 0}
            onChange={items => {
                setZones(removeAllVal(items).map(item=>item.value));
            }}
            options={getZonesOptions()}
            placeholder="Select Zone"
            menuPortalTarget={document.body}
        />);
    };

    const renderZipcodeSelect = () => {
        return (<Select
            isMulti={true}
            menuIsOpen={isZipcodeMenuOpen}
            onFocus={e => setIsZipcodeMenuOpen(true)}
            onBlur={e => {
                setIsZipcodeMenuOpen(false);
                setFinalValues();
            }}
            components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MultiValue }}
            hideSelectedOptions={false}
            styles={styles}
            value={populateValues(selectedZipcodeValues())}
            isClearable={selectedZipcodeValues().length != 0}
            onChange={items => {
                setZipcodes(removeAllVal(items).map(item=>item.value));
            }}
            options={getZipcodesOptions()}
            placeholder="Select Zipdecode"
            menuPortalTarget={document.body}
        />);
    };

    const styles: StylesConfig<ColourOption, true> = {
        control: (base, state) => ({
            ...base,
            "border-top": "0",
            "border-left": "0",
            "border-right": "0",
            "border-radius": "0",
            boxShadow: state.isFocused ? 0 : 0,
        }),
        option: (base, {isFocused, isSelected, isMulti}) => ({
            ...base,
            color: isFocused
                ? '#000'
                : isSelected
                    ? '#000'
                    : undefined,
            background: isFocused
                ? 'rgba(0, 0, 0, 0.08)'
                : isSelected
                    ? 'rgba(0, 0, 0, 0.07)'
                    : undefined,
            ":hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
            ":before": {
                content: isMulti 
                    ?  isSelected
                        ? '"☑ "' 
                        : '"☐ "' 
                    : '""'
            }
        }),
        singleValue: (base, state) => ({
            ...base,
            "color": "#316CF4"
        }),
        multiValue: (base, state) => ({
            ...base,
            "color": "#316CF4",
            "background-color": "#fff",
            "border": "1px solid #c0c0c0",
            "border-radius": "12px",
        }),
        menuPortal: provided => ({ ...provided, zIndex: 9999 }),
        //menu: provided => ({ ...provided, zIndex: 9999 }),
        multiValueRemove: (base, state) => ({
            ...base,
            "opacity": (state.data.value == "ALL") ? "0" : "1",
            "width": (state.data.value == "ALL") ? "0" : "auto",
            ":hover": {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                "border-top-right-radius": "12px",
                "border-bottom-right-radius": "12px",
            },
        }),
        multiValueLabel: (styles: any) => ({
            ...styles,
            whiteSpace: "normal",
            "color": "#316CF4",
        }),
    };

    return (<>
        {getStatesOptions().length ? <div
            key={`${ele.name}_state`}
            title={"Grouping of state based on geographic location, used to define market regions."}
            className={
            `filter-name ${ele.advance ? "filter-advanced" : ""} ${ele?.size ? ele?.size : ""} ${ele.name}-state-label-filter-name` +
            (ele.disabled ? " disabled" : "")
            }
        >
            {<div className="name-top">{"State"}</div>}
            {renderStateSelect()}
        </div>: <></>}
        <div
            key={`${ele.name}_zone`}
            title={"Grouping of zone based on geographic location, used to define market regions."}
            className={
            `filter-name ${ele.advance ? "filter-advanced" : ""} ${ele?.size ? ele?.size : ""} ${ele.name}-zone-label-filter-name` +
            (ele.disabled ? " disabled" : "")
            }
        >
            {<div className="name-top">{"Zone"}</div>}
            {renderZoneSelect()}
        </div>
        <div
            key={`${ele.name}_zipcode`}
            title={"Option to include specific zip codes for all pricing computations."}
            className={
            `filter-name ${ele.advance ? "filter-advanced" : ""} ${ele?.size ? ele?.size : ""} ${ele.name}-zipcode-label-filter-name` +
            (ele.disabled ? " disabled" : "")
            }
        >
            {<div className="name-top">{"Zipcode"}</div>}
            {renderZipcodeSelect()}
        </div>
    </>);

};

export default FilterStateZoneZipcodeWidget;

const MoreSelectedBadge = ({ items }) => {
    const style = {
        marginLeft: "auto",
        borderRadius: "4px",
        padding: "3px 6px 3px 5px",
        border: "1px solid #c0c0c0",
        borderRadius: "12px",
        order: 99,
        color: '#316CF4',
        fontWeight: 'bold',
        fontSize: '85%'
    };
  
    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length}`;
  
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};

const MultiValue = ({ index, getValue, ...props }) => {
    let stringLimit = 0;
    let maxToShow = 0;
    getValue().map(singleValue => {
        if (stringLimit <= 6) {
            stringLimit += singleValue.value.length;
            maxToShow += 1;
        }
    });
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);
  
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <MoreSelectedBadge items={overflow} />
    ) : null;
};